module.exports = __webpack_public_path__ + "static/media/11.7cf939d9.jpg";